import { createQueryKeys } from '@lukemorales/query-key-factory';

export const adminKeys = createQueryKeys('admin', {
  analyticsTab: () => ['analytics-tab'],
});
